import React from 'react';
import './css/footer.css';
import { getBrandName } from './utils/brand';

const Footer = () => {
    const brandName = getBrandName();
    const host = typeof window !== 'undefined' ? window.location.host.toLowerCase() : '';
    const isGreenline = host.includes('greenline.works');
    const supportUrl = isGreenline ? 'https://greenline.legal/contact' : 'https://kanbanzone.com/contact';
    const termsUrl = isGreenline
        ? 'https://greenline.legal/terms-of-service/'
        : 'https://kanbanzone.com/terms-of-service/';
    const knowledgeBase = isGreenline
        ? 'https://help.greenline.legal/'
        : 'https://kanbanzone.com/knowledge-base/';
    const year = new Date().getFullYear();

    return (
        <footer className="site-footer" role="contentinfo">
            <div className="site-footer-inner">
                <div className="site-footer-brand">
                    <strong>{brandName} Developer Docs</strong>
                    <span className="muted">© {year} {brandName}. All rights reserved.</span>
                </div>
                <ul className="site-footer-links">
                    <li><a href={knowledgeBase} target="_blank" rel="noopener noreferrer">Knowledge Base</a></li>
                    <li><a href={supportUrl} target="_blank" rel="noopener noreferrer">Support</a></li>
                    <li><a href={termsUrl} target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
                </ul>
            </div>
        </footer>
    );
};

export default Footer;
